
import React  , { useState } from "react";
import { Col, Modal,  Row ,ModalHeader, 
    Label, Button, CardBody,Form, Input} from "reactstrap"

import PropTypes from "prop-types";



import { connect, } from "react-redux";
import { withRouter} from "react-router-dom";
import {leadsCreate, leadsLista}  from "../../store/leads/actions"


import SweetAlert from "react-bootstrap-sweetalert";

import './style/style.scss'
const PrecontactoAddModal = (props) => {


    const  [checked, setchecked] = useState(false);
   
    const es_empresa = checked;
    console.log(es_empresa)

    const changeLista = (e) => {
        setchecked(e.target.checked)
      }

    const handleButtonClick = () => {
        props.onCloseClick();
       };

       const[formData, setFormData] = useState({
        first_name:"",
        last_name:"",
        razon_social:"",
        email:"",
        address:"",
        phone:"",
        
      })
     
      const {
        first_name,
        last_name,
        razon_social,
        email,
        address,
        phone,
      } = formData
  
      const onChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value})
      }
     
       

       const onSubmit = (e) => {
        e.preventDefault();
        props.leadsCreate({
            first_name,
            last_name,
            razon_social,
            email,
            address,
            phone,
        });
        
       };

    return ( 
        <React.Fragment>

{props.leadsCreated.id ? (
                                <SweetAlert
                                  title="Hecho!"
                                  success
                                  timeout={1000}
                                  
                                  showConfirm={false}
                                  onConfirm={() => {
                                   
                                    handleButtonClick()
                                    props.leadsLista()
                                  }}
                                >
                                  Se ha agregado el PreContacto  con el numero {props.leadsCreated.id}
                                </SweetAlert>
                              ) : null}

       <Modal isOpen={props.crearModal} toggle={props.onCloseClick} centered={true} >

       <ModalHeader toggle={handleButtonClick} tag="h4">
       Crear Nuevo Pre-Contacto 
                        
                </ModalHeader>

                <CardBody>
                                

                                        <div className="form-check form-switch mb-3">
                                                    <input className="form-check-input mt-2 " type="checkbox" id="flexSwitchCheckChecked" onChange={changeLista} checked = {checked} />
                                                    <Label className="form-check-label mt-2 " for="flexSwitchCheckChecked"><strong>Empresa</strong> </Label>
                                        </div>
                                        <Form className="form-control needs-validation" 
                                         onSubmit={onSubmit}
                                        >
                                                                                   {!checked ? (
                                                  <> {/* Datos Persona Natural*/}
                                                    <Row>
                                                        <Col lg={6} className="mb-3">                    
                                                        <Label
                                                            for="first_name"
                                                            className="form-label"
                                                        >
                                                            Nombre
                                                        </Label>
                                                        <Input
                                                            id="first_name"
                                                            name="first_name"
                                                            type="text"
                                                            onChange={onChange}
                                                            value={first_name}
                                                            required={true}
                                                           
                                                        />
                                                        
                                                    
                                                        </Col>                  
                                                        <Col lg={6}  className="mb-3">                    
                                                        <Label
                                                            for="last_name"
                                                            className="form-label"
                                                        >
                                                            Apellido
                                                        </Label>
                                                        <Input
                                                            id="last_name"
                                                            name="last_name"
                                                            type="text"
                                                            onChange={onChange}
                                                            value={last_name}
                                                          
                                                        />
                                                        
                                                        
                                                        </Col>
                                                    </Row>
                                                  
                                                  <Row>
                                                  <Col lg={6}  className="mb-3">                    
                                                        <Label
                                                            for="email"
                                                            className="form-label"
                                                        >
                                                            Email
                                                        </Label>
                                                        <Input
                                                            id="email"
                                                            name="email"
                                                            type="email"
                                                            onChange={onChange}
                                                            value={email}
                                                           
                                                        />
                                                    </Col>
                                                  </Row>

                                                 
                                                   </>
                                                ):


                                                <>{/* Datos de Empresa */}
                                                   <Row>
                                                        <Col lg={6} className="mb-3">                    
                                                        <Label
                                                            for="razon_social"
                                                            className="form-label"
                                                        >
                                                            Razon Social
                                                        </Label>
                                                        <Input
                                                            id="razon_social"
                                                            name="razon_social"
                                                            type="text"
                                                            onChange={onChange}
                                                            value={razon_social}
                                                            required={true}
                                                          
                                                        />
                                                   
                                                    
                                                        </Col>  
                                                        <Col lg={6}  className="mb-3">                    
                                                        <Label
                                                            for="email"
                                                            className="form-label"
                                                        >
                                                            Email
                                                        </Label>
                                                        <Input
                                                            id="email"
                                                            name="email"
                                                            type="email"
                                                            onChange={onChange}
                                                            value={email}
                                                           
                                                        />
                                                      
                                                        
                                                        </Col>                
                                                       
                                                    </Row>

                                                  
                                                 </> 
                                                 } 

<Row>
                                                        <Col lg={6} className="mb-3">                    
                                                        <Label
                                                            for="address"
                                                            className="form-label"
                                                        >
                                                            Direccion
                                                        </Label>
                                                        <Input
                                                            id="address"
                                                            name="address"
                                                            type="text"
                                                            onChange={onChange}
                                                            value={address}
                                                          
                                                        />
                                                   
                                                    
                                                        </Col>    
                                                        <Col lg={6}  className="mb-3">                    
                                                        <Label
                                                            for="phone"
                                                            className="form-label"
                                                        >
                                                            Telefono
                                                        </Label>
                                                        <Input
                                                            id="phone"
                                                            name="phone"
                                                            type="text"
                                                            onChange={onChange}
                                                            value={phone}
                                                           
                                                        />
                                                      
                                                        
                                                        </Col>              
                                                       
                                                    </Row>

                                                    <Row className="col-lg-12 justify-content-center">
                                                        <Col md={1} className= 'mx-1'>
                                                        <Button color="primary" type="submit">
                                                            Enviar
                                                        </Button>
                                                        </Col>
                                                        <Col md={1} className= 'mx-1'>
                                                        <Button className="btn btn-secondary btn-volver" 
                                                            onClick={handleButtonClick}
                                                            type="button"
                                                        >
                                                            Volver
                                                        </Button>
                                                        </Col>
                                                    </Row>
                                        </Form>
                                        </CardBody>
                                        

       </Modal>

        </React.Fragment>
     );
}
 

const mapStateToProps = (state) => {
    const { error, loading,leadsCreated } = state.Leads;
    return { error, loading, leadsCreated };
  };

  PrecontactoAddModal.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    leadsCreated: PropTypes.object,
  }
  
  
   
export default withRouter(connect(mapStateToProps, {leadsCreate, leadsLista})(PrecontactoAddModal));
